import { render, staticRenderFns } from "./transaction-coordinator.vue?vue&type=template&id=6691967a"
import script from "./transaction-coordinator.vue?vue&type=script&lang=js"
export * from "./transaction-coordinator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports